import React from 'react';

var SvgLogoVimeoIcon = function SvgLogoVimeoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.922 5.189c-.247-1.028-1.406-1.319-2.577-1.14-.6.094-2.628 1-3.32 3.171 1.223-.096 1.864.089 1.747 1.451-.05.57-.333 1.195-.652 1.794-.366.692-1.055 2.047-1.957 1.07-.812-.88-.75-2.561-.935-3.682-.105-.63-.214-1.413-.418-2.06-.174-.557-.576-1.226-1.068-1.373-.528-.155-1.18.09-1.563.319-1.192.707-2.084 1.682-3.107 2.522-.13.131-.053.242-.01.34.147.23.204.369.484.41.728.108 1.42-.686 1.901.142.295.504.387 1.056.575 1.6.25.727.445 1.516.651 2.35.35 1.411.776 3.52 1.982 4.04.614.262 1.538-.09 2.006-.371 1.268-.76 2.299-1.828 3.101-2.984 2.089-3.005 3.09-6.025 3.199-6.6a2.198 2.198 0 0 0-.04-.999Z"
  }));
};
SvgLogoVimeoIcon.displayName = "LogoVimeoIcon";

export { SvgLogoVimeoIcon as S };
